import { RootState } from '../Common/store/rootReducer';
import { ListProps } from './components/List/List';
import { MappedListItem } from './listTypes';

export const activeCTSlugSelector = (state: RootState) => state.list.activeSlug;
export const listIsLoadingSelector = (state: RootState) => state.list.isLoading;
export const isSearchResultListSelector = (state: RootState) =>
    state.list.isSearchResults;
export const searchResultsTermSelector = (state: RootState) =>
    state.list.searchResultsTerm;

export const mappedListSelector = (state: RootState, props: ListProps) => {
    const { listView } = props.activeCurriculumType;
    const listViewHeaderField = listView.header.field.slug;
    const listViewDescriptionField = listView.description.field.slug;
    const listItems = state.list.items;

    return listItems.map(listItem => {
        const headerValue = listItem[listViewHeaderField];
        const descriptionValue = listItem[listViewDescriptionField];
        const listItemUuid = listItem['uuid'];

        const mappedListItem: MappedListItem = {
            uuid: listItemUuid,
            header: headerValue,
            description: descriptionValue,
            _pagePath: listItem['_pagePath'] || null,
            isFetched: listItem['isFetched'] || false,
            isListItemError: listItem['isListItemError'] || false,
        };
        return mappedListItem;
    });
};

export const totalPagesSelector = (state: RootState) => state.list.totalPages;
